// @flow

import React from 'react';
import type { Node } from 'react';

import Title from 'components/Title';

import { Link } from 'react-router-dom';

import { ReactComponent as NumberOneIcon } from 'assets/svg/steps/number-1.svg';
import { ReactComponent as NumberTwoIcon } from 'assets/svg/steps/number-2.svg';
import { ReactComponent as NumberThreeIcon } from 'assets/svg/steps/number-3.svg';

import './style.scss';

type Props = {
  isCompact?: boolean,
  isBlack?: boolean,
};

export default function HowItWorksSteps(props: Props): Node {
  const { isCompact, isBlack } = props;

  return (
    <section className="HowItWorks">
      <article
        className={`HowItWorks__stepsList  ${
          isCompact
            ? 'HowItWorks__stepsList--inline'
            : 'HowItWorks__stepsList--column'
        }`}
      >
        <div className="HowItWorks__stepsListElement">
          <NumberOneIcon />
          <div>
            <Title tag="span" fontSize="s" isBlack={isBlack}>
              Set language & popularity
            </Title>
            {!isCompact && (
              <p>
                Popularity refers to the number of interactions (comments,
                reactions) under issue. Low popularity might be a sign that
                fewer people are interested in that task or repository is less
                popular.
              </p>
            )}
          </div>
        </div>
        <div className="HowItWorks__stepsListElement">
          <NumberTwoIcon />
          <div>
            <Title tag="span" fontSize="s" isBlack={isBlack}>
              Browse issues & find best fit for you
            </Title>
            {!isCompact && (
              <p>
                You can browse all the open issues from different repos that are
                meant for new newcomers. You can read more about which issues we
                fetch on{' '}
                <Link to="how-it-works" className="main-link">
                  {' '}
                  how it works page
                </Link>
              </p>
            )}
          </div>
        </div>
        <div className="HowItWorks__stepsListElement">
          <NumberThreeIcon />
          <div>
            <Title tag="span" fontSize="s" isBlack={isBlack}>
              Start contributing!
            </Title>
            {!isCompact && (
              <p>
                Let&#39;s go! Remember no one will be offended because you try
                to help in his project! If it&#39;`s your first time in OSS
                check out
                <Link to="great-reads" className="main-link">
                  {' '}
                  resources
                </Link>
              </p>
            )}
          </div>
        </div>
      </article>
    </section>
  );
}

HowItWorksSteps.defaultProps = {
  isCompact: false,
  isBlack: false,
};
